import { FC, PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import { useTypedTranslationsWithPartialResult } from '~/components/translation/use-translations';
import textKeyIsSet from '~/utils/textkey-is-set';
import { useParams } from 'react-router-dom';

type CasinoSubNavigationSeoHeaderProps = PropsWithChildren<{
	isLiveCasinoLocation?: boolean;
	titleFallBackTextkey: string;
}>;

const CasinoSubNavigationSeoHeader: FC<CasinoSubNavigationSeoHeaderProps> = ({
	isLiveCasinoLocation,
	children,
	titleFallBackTextkey
}) => {
	const { submenu } = useParams() as { submenu: string };

	const metaTagsTextkeyBase = `CONTENT_COMPONENT_${isLiveCasinoLocation ? 'LIVE_' : ''}CASINO_SUBMENU_${submenu
		.toLocaleUpperCase()
		.replaceAll('-', '_')}`;
	const titleTextKey = `${metaTagsTextkeyBase}_TITLE_TAG`;
	const descriptionTextKey = `${metaTagsTextkeyBase}_META_DESCRIPTION`;
	const typedTranslations = useTypedTranslationsWithPartialResult({
		titleTextKey,
		descriptionTextKey,
		titleFallBackTextkey
	});

	const siteTitle = textKeyIsSet(typedTranslations.translations[titleTextKey])
		? typedTranslations.translations[titleTextKey]
		: typedTranslations.translations[titleFallBackTextkey];
	const description = typedTranslations.translations[descriptionTextKey];

	return (
		<Helmet>
			{textKeyIsSet(siteTitle) && <title>{siteTitle}</title>}
			{textKeyIsSet(description) && <meta name="description" content={description} />}
			{children}
		</Helmet>
	);
};

export default CasinoSubNavigationSeoHeader;
